<template lang="pug">
VueHcaptcha.FcwHCaptcha(
  ref="componentRef"
  :sitekey
  size="invisible"
  @error="handleCaptchaError"
  @verify="handleCaptchaVerify"
)
</template>

<script setup lang="ts">
import VueHcaptcha from '@hcaptcha/vue3-hcaptcha';

const componentRef = ref<VueHcaptcha>();

const { sitekey, handleCaptchaError, handleCaptchaVerify } =
  useHcaptcha(componentRef);
</script>
